import React from 'react';
import classnames from 'classnames';
import styles from './QuestionAnswer.scss';

const QuestionAnswer = ({
	answer, count, total, correct,
}) => (
	<div className={classnames(styles.root, { [styles.correct]: correct })}>
		<div
			className={styles.resultPresenter}
			style={{ width: count ? `${(count / total) * 100}%` : '0%' }}
		/>
		<span className={styles.question}>{answer.text}</span>
		{count && <span className={styles.count}>{count}</span>}
	</div>
);

export default QuestionAnswer;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/question/childcomponents/QuestionAnswer.js